import { Typography } from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { StyledFiltersBar } from "../styles";

type Props = {
  actionIcon?: ReactElement; // injected from the parent
};

const BulkSalaryIncreaseFiltersBar = ({ actionIcon }: Props) => {
  const { t } = useTranslation();
  
  return (
    <StyledFiltersBar>
      <Typography variant="secondary">{t("settings:bulkSalaryIncrease.fetchAndCreateNewLabel")}</Typography>
      {actionIcon}
    </StyledFiltersBar>
  );
};

export default BulkSalaryIncreaseFiltersBar;
